<ng-template appActionBarPortal [forceLayoutClass]="true">
  <cwc-button designVersion="v2" variant="primary" (cwcClick)="onCreatePlant()">Create Plant</cwc-button>
  <cwc-button designVersion="v2" variant="secondary" (cwcClick)="onRefresh()">Refresh</cwc-button>
  <cwc-button designVersion="v2" variant="support" (cwcClick)="onExport()">Export</cwc-button>
</ng-template>

<section>
  <h1>{{ 'planxgo.plantManagement.title' | translate }}</h1>
  <p>Last action: {{ lastAction }}</p>
</section>
